<template>
  <q-input
    v-bind="$attrs"
    :type="showPassword ? 'text' : 'password'"
  >
    <template v-for="[slot, args] of Object.entries($slots)" #[slot]>
      <slot :name="slot" v-bind="args" />
    </template>

    <template v-if="showToggle" #append>
      <q-btn
        dense
        round
        flat
        size="12px"
        :icon="showPassword ? 'visibility_off' : 'visibility'"
        @click="showPassword = !showPassword"
      />
    </template>
  </q-input>
</template>

<script>
export default {
  props: {
    showToggle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPassword: false
    }
  }
}
</script>
